import { render, staticRenderFns } from "./SoilRemediation.vue?vue&type=template&id=de6b124c&scoped=true"
import script from "./SoilRemediation.vue?vue&type=script&lang=js"
export * from "./SoilRemediation.vue?vue&type=script&lang=js"
import style0 from "./SoilRemediation.vue?vue&type=style&index=0&id=de6b124c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6b124c",
  null
  
)

export default component.exports